import { render, staticRenderFns } from "./AddMachineGroupDialog.vue?vue&type=template&id=b8be16f0&scoped=true&"
import script from "./AddMachineGroupDialog.vue?vue&type=script&lang=js&"
export * from "./AddMachineGroupDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../frontend-web/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8be16f0",
  null
  
)

export default component.exports